import { render, staticRenderFns } from "./InspectorRouting.vue?vue&type=template&id=5366061b&scoped=true&"
import script from "./InspectorRouting.vue?vue&type=script&lang=js&"
export * from "./InspectorRouting.vue?vue&type=script&lang=js&"
import style0 from "./InspectorRouting.vue?vue&type=style&index=0&id=5366061b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5366061b",
  null
  
)

export default component.exports